import React, { ReactNode } from "react";
import {
  getABTestVariant,
  getABTestConfig,
  trackABTestEvent,
} from "../utils/advancedAnalytics";

interface ABTestWrapperProps {
  testId: string;
  children:
    | ReactNode
    | ((
        variantId: string | null,
        config: Record<string, any> | null
      ) => ReactNode);
  fallback?: ReactNode;
  trackView?: boolean;
}

const ABTestWrapper: React.FC<ABTestWrapperProps> = ({
  testId,
  children,
  fallback,
  trackView = true,
}) => {
  const variantId = getABTestVariant(testId);
  const config = variantId ? getABTestConfig(testId, variantId) : null;

  // Track view if enabled
  React.useEffect(() => {
    if (trackView && variantId) {
      trackABTestEvent(testId, variantId, "view");
    }
  }, [testId, variantId, trackView]);

  // If no variant is assigned, show fallback or nothing
  if (!variantId) {
    return fallback ? <>{fallback}</> : null;
  }

  // If children is a function, call it with variant info
  if (typeof children === "function") {
    return <>{children(variantId, config)}</>;
  }

  // Otherwise, render children directly
  return <>{children}</>;
};

export default ABTestWrapper;
